import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import is from 'is_js';
import 'bootstrap/dist/css/bootstrap.css';

import 'url-search-params-polyfill';
import './scripts/array-prototype-polyfill';

import store, { history } from './containers/app/store';
import App from './containers/app/App';

// import registerServiceWorker from './scripts/registerServiceWorker';
import './index.css';

const target = document.getElementById('root');

window.mainApp = {};

// Detect Safari browser
window.sqoonyIsSafari = is.safari();
// Detect IE browser
window.sqoonyIsIE = is.ie();

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  target
);

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js